"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var ItemLabel = (0, core_1.styled)('div')({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    position: 'absolute',
    top: -8,
    fontSize: 12,
    fontWeight: 700,
    maxWidth: '100%',
    fontFamily: 'Montserrat'
});
exports.default = ItemLabel;
//# sourceMappingURL=ItemLabel.js.map